// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"43":"component---src-templates-page-press-release-tsx","869":"styles"}[chunkId] || chunkId) + "." + {"43":"ae8a294b2d8ca57a422e","444":"c061b354caec3be045ef","869":"6e307d764ad5d0b63318","994":"b6bf1bf45b47964198a1"}[chunkId] + ".css";
};